import { isEmpty, isUndefined } from '../external/utilities/GeneralUtils'

export const LOB_CAMPING = 'CAMPING'
export const LOB_DAYUSE = 'DAYUSE'
export const LOB_DAYENTRANCE = 'DAYENTRANCE'
export const LOB_HOURLYUSE = 'HOURLYUSE'
export const LOB_TICKETING = 'TICKETING'
export const LOB_PERMITS = 'PERMITS'
export const LOB_RECAREA = 'RECAREA'
export const LOB_RECFACILITY = 'RECFACILITY'
export const LOB_MARINAS = 'MARINAS'
export const LOB_CAMPING_AND_DAYUSE = 'CAMPINGANDDAYUSE'

export const INV_MODEL_PER_PERSON = 'PER_PERSON'
export const INV_MODEL_PER_VEHICLE = 'PER_VEHICLE'

export const isLOBs = function (lobs) {
  if (!isUndefined(lobs) && !isEmpty(lobs) && lobs.length > 0) {
    return true
  }

  return false
}
export const isLOBCamping = function (lob) {
  if (lob === LOB_CAMPING) {
    return true
  }

  return false
}
export const isLOBDayUse = function (lob) {
  if (lob === LOB_DAYUSE) {
    return true
  }

  return false
}
export const isLOBDayPass = function (lob) {
  if (lob === LOB_DAYENTRANCE) {
    return true
  }

  return false
}
export const isLOBHourlySites = function (lob) {
  if (lob === LOB_HOURLYUSE) {
    return true
  }

  return false
}
export const isLOBCampingAndDayUse = function (lob) {
  if (lob === LOB_CAMPING_AND_DAYUSE) {
    return true
  }

  return false
}
export const isLOBCampingOrDayUse = function (lob) {
  if (
    lob === LOB_CAMPING_AND_DAYUSE ||
    lob === LOB_CAMPING ||
    lob === LOB_DAYUSE
  ) {
    return true
  }

  return false
}
export const isLOBCampingOrDayUseOnly = function (lobs) {
  let isCampingOrDayUse = false
  if (isLOBs(lobs) && lobs.length === 1) {
    // eslint-disable-next-line prefer-destructuring
    const singleLOB = lobs[0]
    if (
      singleLOB === LOB_CAMPING_AND_DAYUSE ||
      singleLOB === LOB_CAMPING ||
      singleLOB === LOB_DAYUSE
    ) {
      isCampingOrDayUse = true
    }
  }

  return isCampingOrDayUse
}
export const isLOBHourlySitesOnly = function (lobs) {
  let isHourlySite = false
  if (isLOBs(lobs) && lobs.length === 1) {
    // eslint-disable-next-line prefer-destructuring
    const singleLOB = lobs[0]
    if (singleLOB === LOB_HOURLYUSE) {
      isHourlySite = true
    }
  }

  return isHourlySite
}
export const isLOBCampingOrDayUseOrHourlySitesOnly = function (lobs) {
  let isCampingOrDayUseOrHourlySites = false
  if (isLOBCampingOrDayUseOnly(lobs) || isLOBHourlySitesOnly(lobs)) {
    isCampingOrDayUseOrHourlySites = true
  }

  return isCampingOrDayUseOrHourlySites
}
export const isLOBDayPassOnly = function (lobs) {
  let isDayPass = false
  if (isLOBs(lobs) && lobs.length === 1) {
    // eslint-disable-next-line prefer-destructuring
    const singleLOB = lobs[0]
    if (singleLOB === LOB_DAYENTRANCE) {
      isDayPass = true
    }
  }

  return isDayPass
}
export const hasLOB = function (lobs, lob) {
  let isLOB = false
  if (isLOBs(lobs)) {
    for (const currLOB of lobs) {
      if (currLOB === lob) {
        isLOB = true
        break
      }
    }
  }

  return isLOB
}
export const isSingleLOB = function (lobs) {
  let isSingle = false
  if (isLOBs(lobs) && lobs.length === 1) {
    isSingle = true
  }

  return isSingle
}
export const getCuratedLOBs = function (lobs) {
  let curatedLOBs = null
  let hasCampingAndDayUse = false

  if (isLOBs(lobs)) {
    curatedLOBs = []
    if (hasLOB(lobs, LOB_CAMPING) && hasLOB(lobs, LOB_DAYUSE)) {
      hasCampingAndDayUse = true
      curatedLOBs.push(LOB_CAMPING_AND_DAYUSE)
    }
    for (const lob of lobs) {
      if (isLOBCamping(lob) || isLOBDayUse(lob)) {
        if (!hasCampingAndDayUse) {
          curatedLOBs.push(lob)
        }
      } else {
        curatedLOBs.push(lob)
      }
    }
  }

  return curatedLOBs
}
export const getRedirectObjForLOB = function (lob, redirectObjs) {
  let redirectObj = null
  if (!isUndefined(redirectObjs) && !isEmpty(redirectObjs)) {
    for (const currRedirectObj of redirectObjs) {
      if (lob === currRedirectObj.business) {
        redirectObj = currRedirectObj
        break
      }
    }
  }

  return redirectObj
}
export const isInvModelPerPerson = function (dataObj) {
  if (dataObj.invModel === INV_MODEL_PER_PERSON) {
    return true
  }

  return false
}

export const isInvModelPerVehicle = function (dataObj) {
  if (dataObj.invModel === INV_MODEL_PER_VEHICLE) {
    return true
  }

  return false
}
